import { render, staticRenderFns } from "./ReportFieldGroup.vue?vue&type=template&id=81357e16"
import script from "./ReportFieldGroup.vue?vue&type=script&lang=js"
export * from "./ReportFieldGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports